const defaultState = {
    image: '',
    imagePosition: '',
    imageMobile: '',
    textPosition: '',
    visualizerBlockItems: [],
};

export const visualizer = (state = defaultState) => {
    return state;
};
